// extracted by mini-css-extract-plugin
export var borderIcons = "SocialShare-module--borderIcons--0c45b";
export var iconSize = "SocialShare-module--iconSize--c7427";
export var sectionShare = "SocialShare-module--sectionShare--92af8";
export var titleShare = "SocialShare-module--titleShare--a67bd";